module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\r\n<fieldset class="agenda_plage_tooltip">\r\n  <table>\r\n    <tr>\r\n      <td>\r\n        <label for="agenda_horaire"><b>'+
((__t=(i18n.t("agenda.plagHoraire")))==null?'':__t)+
'</b></label>\r\n        <span class="agenda_horaire"></span>\r\n      </td>\r\n      <td></td>\r\n    </tr>\r\n    <tr>\r\n      <td width="50%">\r\n        <label for="agenda_presence">'+
((__t=(i18n.t("agenda.plagPresence")))==null?'':__t)+
'</label>\r\n        <span class="agenda_presence"></span>\r\n      </td>\r\n      <td width="50%">\r\n        <label for="agenda_temps">'+
((__t=(i18n.t("agenda.plagTemps")))==null?'':__t)+
'</label>\r\n        <span class="agenda_temps"></span>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n\r\n  <table>\r\n    <tr>\r\n      <td width="15%">\r\n        <label for="agenda_plageGraph">'+
((__t=(i18n.t("agenda.plagRepart")))==null?'':__t)+
'</label>\r\n      </td>\r\n      <td>\r\n        <span class="agenda_plageGraph"></span>\r\n      </td>\r\n    </tr>\r\n  </table>\r\n</fieldset>\r\n';
}
return __p;
};
